import { ListItemIcon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import useAllowEditWorkflow from "hooks/useAllowEditWorkflow";
import { useDetermineShareFlowUserAccessType } from "hooks/useDetermineShareFlowUserAccessType";
import { ComponentPropsContextApi } from "layouts/Flow Designer/context";
import { ComponentPropsContext } from "layouts/Flow Designer/context";
import { useContext, useState } from "react";
import { useSelector } from "react-redux";
import { TextField } from "../StyledComponents";
import { styles } from "../..";
import { useDebouncer } from "hooks/useDebouncer";
import AutocompleteInput from "../AutocompleteInput";
import SoftTypography from "components/SoftTypography";
import IconButton from "@mui/material/IconButton";
import { ThemedTrashIcon } from "assets/CXFIcons/Triggers";

export const KeyValueInput = ({ action, item, itemIndex }) => {
  const { actionForm } = useContext(ComponentPropsContext);
  const { setActionForm, setFormErrors } = useContext(ComponentPropsContextApi);
  const { currentSavedFlow } = useSelector((store) => store?.designer?.flows);
  const isFlowActive = currentSavedFlow?.shared_status === "active";
  const { allowEditWorkflow } = useAllowEditWorkflow();
  const { isReadOnlyAccess } = useDetermineShareFlowUserAccessType(currentSavedFlow?.id);
  const [value, setValue] = useState({
    key: item.key,
    value: item.value
  });
  const { debouncer: inputDebouncer } = useDebouncer(handleKeyValueInputChange);

  const handleSetValue = (target) => (event, val) => {
    setValue((prev) => ({
      ...prev,
      [target]: val ? val : event.target.value
    }));
    inputDebouncer({ target });
  };

  function handleKeyValueInputChange({ target }) {
    let actionFormCopy = { ...actionForm };

    actionFormCopy = {
      ...actionFormCopy,
      [action.field]: {
        ...actionFormCopy[action.field],
        value: actionFormCopy[action.field]?.value?.map((item, index) =>
          itemIndex === index ? { ...item, [target]: value[target], isVariable: false } : item
        )
      }
    };

    setFormErrors((prev) => prev.filter((error) => error !== action.field));

    setActionForm(actionFormCopy);
  }

  const deleteKeyValue = (field) => (event) => {
    event.stopPropagation();
    if (isFlowActive || !allowEditWorkflow(isReadOnlyAccess)) return;

    let actionFormCopy = { ...actionForm };

    actionFormCopy = {
      ...actionFormCopy,
      [field]: {
        ...actionFormCopy[field],
        value: actionFormCopy[field]?.value?.filter((item, index) => index !== itemIndex)
      }
    };

    setActionForm(actionFormCopy);
  };

  return (
    <SoftBox display="flex" alignItems="center" width="100%">
      <SoftBox width="100%">
        <SoftBox sx={{ marginBottom: "12px" }}>
          <TextField
            label={"Key"}
            name={action.field}
            placeholder={action.placeholder || ""}
            sx={styles.w100}
            value={value.key}
            onChange={handleSetValue("key")}
            type={"text"}
            variant="outlined"
            disabled={isFlowActive || !allowEditWorkflow(isReadOnlyAccess)}
          />
          {actionForm[action.field]?.value[itemIndex]?.key?.includes("@") && (
            <SoftTypography
              color="warning"
              sx={{
                fontSize: "12px",
                marginTop: "4px",
                opacity: ".7"
              }}
            >
              ⓘ Field does not support context selection
            </SoftTypography>
          )}
        </SoftBox>
        <SoftBox>
          <AutocompleteInput
            action={action}
            fieldValue={value.value}
            onChange={handleSetValue("value")}
            keyValueInput={{ index: itemIndex, name: "Value" }}
            disabled={isFlowActive || !allowEditWorkflow(isReadOnlyAccess)}
            noValidate
          />
        </SoftBox>
      </SoftBox>
      {!isFlowActive && allowEditWorkflow(isReadOnlyAccess) ? (
        <ListItemIcon className="delete-variable-icon-wrapper" sx={{ top: "12px" }}>
          <Tooltip placement="left" title="Delete">
            <IconButton onClick={deleteKeyValue(action.field)}>
              <ThemedTrashIcon className="delete-variable-icon" fontSize="medium" />
            </IconButton>
          </Tooltip>
        </ListItemIcon>
      ) : null}
    </SoftBox>
  );
};
